<template>
    <div id="contenedor-main-proyectos-tareas">
        TAREAS
    </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>

</style>
